import { Injectable } from '@angular/core';

declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor() {}

  showAlert(message: string, type: string, containerId?: string) {
    let htmlContent, ele;

    if (containerId != '' && containerId != undefined && containerId != null) {
      ele = $(containerId);
    } else {
      ele = $('#error-display');
    }

    if (type == 'success') {
      htmlContent =
        `<div class="alert alert-success">
      <button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>
      <i class="fa fa-check sign"></i><strong>Success!</strong> ` +
        message +
        `
      </div>`;
    } else if (type == 'error') {
      htmlContent =
        `<div class="alert alert-danger">
      <button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>` +
        message +
        `</div>`;
    } else if (type == 'info') {
      htmlContent =
        `<div class="alert alert-info">
      <button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>
      <i class="fa fa-info-circle sign"></i><strong> Info! </strong> ` +
        message +
        `
      </div>`;
    } else if (type == 'error_with_sign') {
      htmlContent =
        `<div class="alert alert-danger">
      <button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>
      <i class="fa fa-times-circle sign"></i><strong> Error! </strong> ` +
        message +
        `
      </div>`;
    } else if (type == 'success_with_sign') {
      htmlContent =
        `<div class="alert alert-success">
      <button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>
      <i class="fa fa-check sign"></i><strong> Success! </strong> ` +
        message +
        `
      </div>`;
    }

    ele.html(htmlContent);
  }
}
